import { Injectable } from "@angular/core";
import { GenericService } from "./generic.service";
import { NotificationsService } from "angular2-notifications";
import { DiversionCentreApi } from "../api/diversion-centre.api";
import { IDiversionCentre } from "../model/diversion-centre.model";
import { BehaviorSubject, Observable } from "rxjs";
import { apiCallWrapper, createUrl } from "../api/api.util";

@Injectable()
export class DiversionCentreService extends GenericService<IDiversionCentre> {
  private applyFilter = new BehaviorSubject<string>('dashboard');
  constructor(
    public diversionCentreApi: DiversionCentreApi,
    public notifications: NotificationsService
  ) {
    super(diversionCentreApi, notifications);
  }


  setFilterCriteria(applyFilter: string) {
    this.applyFilter.next(applyFilter);
  }

  getApplyFilter(): Observable<string> {
    return this.applyFilter.asObservable();
  }

  listingDiversionCentre(query: {
    page: number;
    limit: number;
    search: string;
    filter: Record<string, unknown>
  }) {
    return apiCallWrapper(
      this.diversionCentreApi.listingDiversionCentre(query),
      {
        notificationsService: this.notifications,
        action: `Fetching Diversion Centre Records`
      }
    );
  }

  // Admin-only: DELETE with reason in body
  deleteWithReason(id: string | number, reason: string) {
    const url = createUrl(this.diversionCentreApi.path, id);
    return apiCallWrapper(
      this.diversionCentreApi.httpClient.request<{ success: boolean; deleted?: number }>(
        'DELETE',
        url,
        { body: { reason } }
      ),
      {
        notificationsService: this.notifications,
        action: `Deleting diversion centre ${id}`
      }
    );
  }

  // Admin-only: Fetch audit entries for a record
  getAudits(id: string | number) {
    // Backend route shape: GET /diversion-centre/:id/audit
    const url = `${createUrl(this.diversionCentreApi.path, id)}/audit`;
    return apiCallWrapper(
      this.diversionCentreApi.httpClient.get<any>(url),
      {
        notificationsService: this.notifications,
        action: `Fetching Diversion Centre Audit ${id}`,
        defaultValue: { items: [] }
      }
    );
  }
}